"use strict";
exports.__esModule = true;
exports.logDebugAction = exports.registerDebugObserver = void 0;
var observers = [];
function registerDebugObserver(observer, eventTypes) {
    var entry = { observer: observer, types: eventTypes };
    observers.push(entry);
    return function () {
        observers.splice(observers.indexOf(entry), 1);
    };
}
exports.registerDebugObserver = registerDebugObserver;
function logDebugAction(action) {
    observers.forEach(function (_a) {
        var _b;
        var observer = _a.observer, types = _a.types;
        if ((_b = types === null || types === void 0 ? void 0 : types.includes(action.type)) !== null && _b !== void 0 ? _b : true) {
            observer(action);
        }
    });
}
exports.logDebugAction = logDebugAction;
//# sourceMappingURL=index.js.map